import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
// import Vue from 'vue'
import { mapGetters } from 'vuex';
var mi = {
  computed: _objectSpread({}, mapGetters(['$MaintainDeliveryNote2State', '$OutsourcedState', '$DeliveryCodeOrderState', '$OuterBoxLabelManagementOrderState', '$DnbarcodeHandmadeState', '$DnbarcodeHandmadeOutBoxState', '$SubDeliveryNoteState'])),
  methods: {
    $setOrderStatu: function $setOrderStatu(status) {
      var route = this.$route.path.substr(1) + '/setOrderStatu';
      return this.$store.dispatch(route, status);
    }
  }
};
export default {
  install: function install(Vue) {
    Vue.mixin(mi);
  }
};